/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeServicesListServices } from "../../funcs/computeServicesListServices.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListServicesRequest$inboundSchema,
};

export const tool$computeServicesListServices: ToolDefinition<typeof args> = {
  name: "compute-services-list-services",
  description: `List services`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeServicesListServices(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
